import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { createGlobalStyle } from 'styled-components'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { createTheme } from '@mui/material/styles'
import { ThemeProvider } from '@mui/material'

import { store, persistor } from 'store'
import { COLOURS } from 'resources'
import Router from './routes/Router'

const GlobalStyle = createGlobalStyle`
  body {
    font-family: 'EBGaramond', serif;
    color: ${COLOURS.neutralBlack};
  }

  .modal .modal-dialog {
    max-width: 620px;
    padding: .5rem;
  }

  .grecaptcha-badge {
    visibility: hidden;
  }
`

const muiTheme = createTheme({
  typography: {
    fontFamily: "'EBGaramond', serif",
  },
})

const App = () => (
  <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}>
    <GlobalStyle />
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={muiTheme}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <Router />
          </LocalizationProvider>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </GoogleReCaptchaProvider>
)

export default App
